import DOMPurify from 'dompurify';

export const vSafeHtml = {
  mounted(el, binding) {
    el.innerHTML = DOMPurify.sanitize(binding.value ?? '');
  },
  updated(el, binding) {
    el.innerHTML = DOMPurify.sanitize(binding.value ?? '');
  },
};

export function installSafeHtml(app) {
  app.directive('safe-html', vSafeHtml);
}
